import routes from "@/utils/routes";
import { matchRoutes, useLocation, useParams } from "react-router-dom";

const useCurrentPathKey = () => {
  const location = useLocation();

  const { teamId } = useParams();

  const matchedRoutes = matchRoutes(
    routes.map((route) => {
      return { path: `/teams/${teamId}/${route.path}` };
    }),
    location
  );
  return matchedRoutes?.[0]?.route?.path?.replace(`/teams/${teamId}/`, "");
};

export default useCurrentPathKey;
